import EpiComponent from '@episerver/spa-core/EpiComponent';
import FuturePaymentsBlockData from 'Models/Content/FuturePaymentsBlockData';
import React, {ReactNode, ReactNodeArray} from 'react';
import FuturePaymentsBlockMain from './FuturePaymentsBlockMain.js';

export default class FuturePaymentsBlock extends EpiComponent<FuturePaymentsBlockData> {
  constructor(props) {
    super(props);
  }

  public render(): ReactNode | ReactNodeArray | null {
    return <FuturePaymentsBlockMain context={this.getContext()} iContent={this.props.data} />;
  }
}
